import React, { useEffect, useState } from 'react';
import { Box, Container, Skeleton, Typography } from '@mui/material';

import statsService from '../../features/stats/statsService';

const TILES = [
  { key: 'tournaments', label: 'Tournaments run' },
  { key: 'gamesScored', label: 'Games scored' },
  { key: 'endsScored', label: 'Ends scored' },
  { key: 'venues', label: 'Clubs & venues' }
];

const HomeStats = () => {
  const [stats, setStats] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let mounted = true;
    statsService
      .getPublic()
      .then((data) => {
        if (mounted) setStats(data);
      })
      .catch(() => {
        if (mounted) setFailed(true);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (failed) return null;

  // While loading, reserve the full four-tile layout (the common case) so the
  // band does not jump when the response lands; drop the ends tile afterwards
  // only when the snapshot does not have a number for it.
  const showEnds = !stats || typeof stats.endsScored === 'number';
  const tiles = TILES.filter((tile) => showEnds || tile.key !== 'endsScored');

  return (
    <Box
      component="section"
      sx={{ py: { xs: 6, md: 8 }, borderTop: 1, borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gap: 3,
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              md: showEnds ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)'
            }
          }}>
          {tiles.map((tile) => (
            <Box key={tile.key} sx={{ textAlign: 'center', minWidth: 0 }}>
              {stats ? (
                <Typography variant="h4" fontWeight={800}>
                  {Number(stats[tile.key]).toLocaleString('en-US')}
                </Typography>
              ) : (
                <Skeleton variant="text" width={96} sx={{ mx: 'auto' }} />
              )}
              <Typography variant="overline" color="text.secondary">
                {tile.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default HomeStats;
